import { Validation } from '@vuelidate/core';
import { createContext } from '@berlin-front/common/composables/context';
import { UnwrapRef, Ref } from '@vue/composition-api';
import type { ValidatorTypeToGetError, Rule } from '@berlin-front/common/composables/validator';

type InputType = {
  atoneId: string;
  password: string;
};

export type ValidatorType = Ref<Validation<Rule<InputType>>>;

export type GetErrorType = ValidatorTypeToGetError<ValidatorType>;

export type AuthLoginAtoneMemberContextType = {
  useLogin: () => UnwrapRef<{
    title: string | undefined;

    state: InputType;

    progressIsLoading: boolean;
    progress: number;
    messages: string[];

    submitButton: {
      isDisabled: boolean;
      onClick: () => void;
    };
    /** 入力正規化制御（全角半角矯正変換等） */
    normalize: () => void;

    /** パスワード再設定画面への遷移を行う。  */
    openMyPageRemind: (() => void) | undefined;
    /** ヘルプ画面への遷移を行う。  */
    showHelp: (() => void) | undefined;
    /** 前の画面への遷移を行う。 */
    goBack: (() => void) | undefined;

    v$: ValidatorType;
    getError: GetErrorType;

    TERMS_OF_USE_URL: string | undefined;
  }>;
};

export const AuthLoginAtoneMemberContext = createContext<AuthLoginAtoneMemberContextType>(
  {} as AuthLoginAtoneMemberContextType,
);
